module.exports = __webpack_public_path__ + "e6cb016e866e5e6ecb5ae3035a58852c.MP3";